'use strict';

import React, {PropTypes} from 'react';
import AccordionListItem from './AccordionListItem';
import cx from 'classnames';
import {isNil} from 'lodash';

export default class AccordionList extends React.Component {
    static propTypes = {
      children: React.PropTypes.arrayOf(PropTypes.element),
      onToggle: PropTypes.func
    }

    constructor(props, context) {
      super(props, context);
      this.state = {
        openIndex : null
      };
    }

    handleToggle(index) {
      const openIndex =
        (index !== null &&
          index !== this.state.openIndex &&
          index >= 0 && index < React.Children.count(this.props.children)) ?
          index : null;
      this.setState({openIndex});
      if (this.props.onToggle) {
        this.props.onToggle();
      }
    }

    render() {
      let index = 0;
      const handler = this.handleToggle.bind(this);
      const children = React.Children.map(this.props.children, child => {
        const current = index++;
        return React.cloneElement(child, {...this.state, index:current, onToggle: handler.bind(this, current)});
      });
      return (
        <div className='accordion-container'>
          <div className={cx('scroll-hide', {collapsed: isNil(this.state.openIndex)})}>
            { children }
          </div>
        </div>
      );
    }
}

export {AccordionListItem};



// WEBPACK FOOTER //
// ./shared/common/components/AccordionList/index.js